import React from 'react';
import grindImage from '../assets/grind-goals.png';

function GrindExplainer() {
  return (
    <div style={{
      backgroundColor: '#1a1a1a',
      borderRadius: '12px',
      padding: '30px 20px',
      textAlign: 'center',
      marginBottom: '30px',
    }}>
      <h2 style={{
        fontFamily: 'Bangers, sans-serif',
        fontSize: 'clamp(1.5rem, 4vw, 2rem)',
        letterSpacing: '2px',
        color: '#FFD700',
        marginBottom: '12px',
      }}>
        💡 What is a GRIND Goal?
      </h2>
      <p style={{
        color: '#ccc',
        fontSize: '1rem',
        marginBottom: '24px',
        maxWidth: '600px',
        margin: '0 auto 24px auto',
      }}>
        The GRIND Goal Framework helps you set powerful, focused goals that connect with your personal why and push you toward growth.
      </p>
      <img
        src={grindImage}
        alt="GRIND Goals Framework"
        style={{
          width: '100%',
          maxWidth: '500px',
          borderRadius: '12px',
          display: 'block',
          margin: '0 auto',
        }}
      />
    </div>
  );
}

export default GrindExplainer;
